import {Component, OnInit} from '@angular/core';
import {IntelligenceService} from '../../../services/intelligence.service';
import {IntelligenceData} from '../../../models/intelligence-data.interface';
import {ActivatedRoute, Router} from '@angular/router';
import {buildQueryParams, getFiltersFromQueryParams} from '../../../utils/filters-utils';
import {IntelligenceSearchInterface} from '../../../models/intelligence-search.interface';

@Component({
  selector: 'app-systems-in-country',
  templateUrl: './systems-in-country.component.html',
  styleUrls: ['./systems-in-country.component.scss']
})
export class SystemsInCountryComponent implements OnInit {

  text = 'Systems in Countries';
  subtitle = '';
  data!: IntelligenceData[];

  constructor(private readonly intelligenceService: IntelligenceService,
              private readonly router: Router,
              private readonly activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      const search = getFiltersFromQueryParams(params);

      this.intelligenceService.getSystemsMap(search.region).subscribe(response => {
        this.data = response;
      });
    });
  }

  searchData(event: IntelligenceSearchInterface): void {
    this.router.navigate([this.router.url.split('?')[0]], {queryParams: buildQueryParams({year: event?.year, region: event?.region})});
  }

}
